import Vue from "vue";
import { router } from "@/plug/life-cycle";
import store from "@/store";
import { _api_carcloud } from "@/service/axios";

// 获取登陆信息
export async function checkBroser(params) {
  const url = `/bt-account-authority-api/authority/v1.0/toB/jump/getDecryptInfoInUrl`;
  return await _api_carcloud.post(url, params).then((res) => {
    return res.data || null;
  });
}

// 登出
export async function httpAxios() {
  const url = `/bt-account-authority-api/authority/v1.0/toB/login/loginOut`;
  if (sessionStorage.getItem("bt_isSingle") === "true") {
    return await _api_carcloud.get(url).then((res) => {
      sessionStorage.clear();
      const result = res.data;
      if (result.code === "000000") {
        window.location.href = result.data;
      }
    });
  } else {
    sessionStorage.clear();
    router.push("/login");
  }
}

// 获取路径
export function getDomain(weburl) {
  var urlReg = /http(s)?:\/\/([^\/]+)/i;
  let domain = weburl.match(urlReg);
  return domain != null && domain.length > 0 ? domain[0] : "";
}
// 获取路径上的参数
export function getParam(url, name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = url.split("?")[1].match(reg);
  if (r != null) {
    return r[2];
  }
  return ""; //如果此处只写return;则返回的是undefined
}
